import { render, staticRenderFns } from "./PrevButton.vue?vue&type=template&id=572cccfe&functional=true&"
var script = {}
import style0 from "./PrevButton.vue?vue&type=style&index=0&id=572cccfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports